import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Form, Input, Select, Row, Col } from 'antd';
import styles from '../css/create.module.css';
import logoFacebook from '../assets/desktop_live_ic_facebook@2x.png';

const FormItem = Form.Item;
const { OptGroup, Option } = Select;

// const SHARE_TYPE = ['timeline', 'page', 'group'];
const SHARE_TYPE = ['timeline', 'page'];

@inject('app', 'fb')
@observer
class CreateForm extends Component {
  state = {
    shareTo: 'timeline',
    submitLock: false
  };

  handleShareSelectChange = shareTo => {
    this.setState({
      shareTo,
    });
  };

  handleCreate = () => {
    const { app, fb, form } = this.props;
    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      this.setState({submitLock: true});
      fb.create(values, {
        success: () => {
          this.setState({submitLock: false});
          
          form.resetFields();
          app.routePush('/live/facebook');
        },
        fail: () => {
          this.setState({submitLock: false});
        }
      });
    });
  };

  getShareOptions = () => {
    const { app, fb, form } = this.props;
    const { langs } = app;
    const { friends, pages, groups } = fb;
    const { getFieldDecorator } = form;

    switch (this.state.shareTo) {
      case 'timeline':
        const systemPermissions = [
          {
            value: 'EVERYONE',
            label: langs['live_fb_create_form_share_timeline_enum_everyone'],
          },
          {
            value: 'ALL_FRIENDS',
            label: langs['live_fb_create_form_share_timeline_enum_all_friends'],
          },
          {
            value: 'FRIENDS_OF_FRIENDS',
            label: langs['live_fb_create_form_share_timeline_enum_friends_of_friends'],
          },
          {
            value: 'SELF',
            label: langs['live_fb_create_form_share_timeline_enum_self'],
          },
        ];
        const customPermissions = friends.map(({ id, name }) => {
          return {
            value: 'CUSTOM',
            allow: id,
            label: name,
          };
        });

        return (
          <FormItem label={langs['live_fb_create_form_perm_label']}>
            {getFieldDecorator('permission', {
              rules: [
                {
                  required: true,
                  message: langs['live_fb_create_form_perm_message'],
                },
              ],
            })(
              <Select>
                <OptGroup
                  label={langs['live_fb_create_form_perm_group_system']}
                >
                  {systemPermissions.map((p, i) => {
                    const { label, value } = p;
                    return (
                      <Option key={`sys_${i}`} value={value}>
                        {label}
                      </Option>
                    );
                  })}
                </OptGroup>
                {customPermissions.length === 0
                  ? <Option key="0" value="none" disabled>
                      Disabled
                    </Option>
                  : <OptGroup
                      label={langs['live_fb_create_form_perm_group_custom']}
                    >
                      {customPermissions.map((p, i) => {
                        const { label, value, allow } = p;
                        return (
                          <Option key={`cus_${i}`} value={`${value}#${allow}`}>
                            {label}
                          </Option>
                        );
                      })}
                    </OptGroup>}
              </Select>
            )}
          </FormItem>
        );

      case 'page':
        return (
          <FormItem label={langs['live_fb_create_form_page_label']}>
            {getFieldDecorator('page', {
              rules: [
                {
                  required: true,
                  message: langs['live_fb_create_form_page_message'],
                },
              ],
            })(
              <Select>
                {pages.map((p, i) => {
                  const { name, id } = p;
                  return (
                    <Option key={i} value={id}>
                      {name}
                    </Option>
                  );
                })}
              </Select>
            )}
          </FormItem>
        );

      case 'group':
        return (
          <FormItem label={langs['live_fb_create_form_group_label']}>
            {getFieldDecorator('group', {
              // initialValue: 'public',
              rules: [
                {
                  required: true,
                  message: langs['live_fb_create_form_group_message'],
                },
              ],
            })(
              <Select>
                {groups.map((p, i) => {
                  const { name, id } = p;
                  return (
                    <Option key={i} value={id}>
                      {name}
                    </Option>
                  );
                })}
              </Select>
            )}
          </FormItem>
        );

      default:
        return null;
    }
  };

  render() {
    const { form, app } = this.props;
    const { langs } = app;
    const { getFieldDecorator } = form;

    return (
        <Form layout="vertical">
          <FormItem label={langs['live_fb_create_form_title_label']}>
            {getFieldDecorator('title', {
              rules: [
                {
                  required: false,                  
                },
              ],
              initialValue: '',
            })(<Input />)}
          </FormItem>
          <FormItem label={langs['live_fb_create_form_desc_label']}>
            {getFieldDecorator('description', {
              rules: [
                {
                  required: false,
                },
              ],
              initialValue: '',
            })(<Input type="textarea" />)}
          </FormItem>
          <FormItem label={langs['live_fb_create_form_share_label']}>
            {getFieldDecorator('share', {
              rules: [
                {
                  required: true,
                  message: langs['live_fb_create_form_share_message'],
                },
              ],
            })(
              <Select onChange={this.handleShareSelectChange}>
                {SHARE_TYPE.map((t, i) => {
                  return (
                    <Option key={i} value={t}>
                      {langs[`live_fb_create_form_share_enum_${t}`]}
                    </Option>
                  );
                })}
              </Select>
            )}
          </FormItem>
          {this.getShareOptions()}

          <Button
            type="primary"
            onClick={this.handleCreate}
            loading={this.state.submitLock}
          >
            {langs['live_create']}
          </Button>
        </Form>
    );
  }
}

const CollectionCreateForm = Form.create()(CreateForm);

@inject('app', 'fb')
@observer
export default class Create extends Component {
  componentDidMount() {
    const { app, fb } = this.props;
    app.setBreadcrumbs(['live', 'facebook_streams', 'facebook_create'], 'facebook');

    if (!fb.accessToken) {
      app.routePush('/live/facebook');
    } else {
      fb.load();
    }
  }

  render() {
    return (
      <div className={styles.content}>
        <Row gutter={16}>
          <Col xs={24} md={6}>
            <img src={logoFacebook} className={styles.logo}></img>
          </Col>
          <Col xs={24} md={18}>
            <CollectionCreateForm />
          </Col>
        </Row>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/live/fb/create.js